import * as actionTypes from '../constants/action.types'
import actionCreator from '../utils/actions/creator'

export const executeRecaptcha = actionCreator(
  actionTypes.FORM_EXECUTE_RECAPTCHA
)
